import { Brand, BrandId, getBrand } from './brand';
import { EnvironmentType } from './environment-type.enum';
import { environments } from './environments';

export interface Environment {
  url: string;
  title: string;
  brandId: BrandId;
  brand?: Brand;
  type: EnvironmentType;
  clientId: string;
  workosApiHostname?: string;
  mgmtUrl: string;
  signalREndpoint: string;
  acUrl: string;
  registrationPagesUrl?: string;
  appInsightsConnectionString: string;
}

// Cache the environment so we don't have to recompute it (it acts like a singleton)
let environment: Environment | null = null;

export function getEnvironment(): Environment {
  if (environment) {
    return environment;
  }

  // Attempt to match the hostname to an environment (or the first test environment)
  const matchingEnvironment =
    environments.find((environment) => {
      return environment.url === window.location.hostname || environment.url.endsWith(window.location.hostname);
    }) ?? environments.filter((env) => env.type === EnvironmentType.Test)[0];

  // For debugging purposes, we can override the brand by using sessionStorage (but this will be cleared on refresh)
  // Override it by setting sessionStorage.setItem('brand', 'lastk')
  const brandId = sessionStorage.getItem('brand');
  if (brandId) {
    matchingEnvironment.brandId = brandId as BrandId;
  }
  matchingEnvironment.brand = getBrand(matchingEnvironment.brandId);
  environment = matchingEnvironment;
  return environment;
}
